module.exports = __webpack_public_path__ + "img/40_22.24e81902.png";